import styled from "styled-components"

export const List = styled.ul`
  display: flex;
  gap: 0.25rem;
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    margin: 0;
  }
  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 38px;
    min-height: 38px;
    padding: 0 0.5rem;
    border-radius: var(--radius);
    font-weight: 600;
    font-size: 0.875rem;
    color: var(--muted);
    text-decoration: none;
    &:hover {
      color: var(--navy);
      background: var(--wash);
    }
    &.active {
      color: var(--navy);
      background: var(--wash);
    }
  }
`
